import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

// Small floating SOS pill, bottom-left, opens the emergency numbers page.
export default function SOSButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useLang();
  if (pathname === "/emergency") return null;
  return (
    <button
      data-testid="sos-button"
      type="button"
      onClick={() => navigate("/emergency")}
      aria-label={`SOS – ${t.sos}`}
      className="fixed left-3 bottom-4 md:left-4 md:bottom-4 z-50 inline-flex items-center gap-1 rounded-full bg-rowan hover:bg-[#8e4c44] text-parchment pl-1.5 pr-2 py-1 text-[10px] font-extrabold shadow-journal transition-[background-color,transform] duration-200 hover:scale-105 before:absolute before:-inset-x-2 before:-inset-y-3 before:content-['']"
    >
      <LifeBuoy className="w-3 h-3" />
      <span className="tracking-wider">SOS</span>
    </button>
  );
}
